import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
} from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './auth.config'; // see authConfig.ts code bellow
import './scss/styles.scss';
import { RouterProvider } from 'react-router-dom';
import router from './router';
import './setupAppInsights';
import Auth from './components/templates/Auth';
import { ErrorBoundary } from './setupAppInsights';

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      msalInstance.setActiveAccount(account);
    }
  });

  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      {/* Our custom Error boundary placed here to avoid React router's own Error boundary */}
      <ErrorBoundary>
        <MsalProvider instance={msalInstance}>
          <Auth>
            <RouterProvider router={router} />
          </Auth>
        </MsalProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
});
